import { defineComponent as a, computed as l, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as h, createCommentVNode as d, normalizeStyle as m } from "vue";
const _ = ["viewBox"], v = /* @__PURE__ */ e("mask", { id: "c8b98c96-1343-48c0-a260-b8b37b640cf8" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), f = { mask: "url(#c8b98c96-1343-48c0-a260-b8b37b640cf8)" }, u = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M256 0h256v512H0V256Z"
}, null, -1), p = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"
}, null, -1), z = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "m345 256 4.8 14.6H365l-12.4 9 4.7 14.6-12.4-9-12.4 9 4.8-14.6-12.4-9h15.3zm-63 26 13.7 7 10.9-10.8-2.4 15.1 13.6 7-15.1 2.4-2.4 15.1-7-13.6-15.1 2.4 10.8-10.9zm-26 63 14.6-4.7V325l9 12.4 14.6-4.8-9 12.4 9 12.4-14.6-4.7-9 12.4v-15.3zm26 63 7-13.6-10.8-10.9 15.1 2.4 7-13.6 2.4 15 15.1 2.5-13.6 7 2.4 15-10.9-10.8zm63 26-4.7-14.5H325l12.4-9-4.8-14.6 12.4 9 12.4-9-4.7 14.6 12.4 9h-15.3zm63-26-13.6-7-10.9 10.9 2.4-15.2-13.6-7 15-2.3 2.5-15.1 7 13.6 15-2.4-10.8 10.9zm26-63-14.5 4.8V365l-9-12.4-14.6 4.7 9-12.4-9-12.4 14.6 4.8 9-12.4v15.3zm-26-63-7 13.7 10.9 10.9-15.2-2.4-7 13.6-2.3-15.1-15.1-2.4 13.6-7-2.4-15.1 10.9 10.8z"
}, null, -1), V = { fill: "none" }, b = ["r"], H = /* @__PURE__ */ a({
  __name: "ck",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(n) {
    const t = n, o = l(() => 512 + 2 * t.strokeWidth), s = l(() => -t.strokeWidth), r = l(() => 256 + t.strokeWidth / 2);
    return (x, w) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      v,
      e("g", f, [
        t.flagName ? (c(), i("title", u, h(t.flagName), 1)) : d("", !0),
        k,
        p,
        g,
        z
      ]),
      e("g", V, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: m({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, _));
  }
});
export {
  H as default
};
//# sourceMappingURL=ck-7a5cd8cc.js.map
